function Footer() {
  return (
    <footer>
      <p>@Lowri Roberts 2023</p>
    </footer>
  );
}

export default Footer;
